import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { api, errMsg } from "@/lib/api";

const inputCls = "w-full border-0 border-b border-white/15 bg-transparent px-0 py-3 text-base text-bone placeholder:text-zinc-500 focus:border-brand focus:outline-none";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-ink px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="chamfer w-full max-w-md border border-white/10 bg-coal p-8 md:p-10">
        <Link to="/" data-testid="admin-login-home-link"><Logo /></Link>
        <h1 className="font-display mt-10 text-3xl font-black uppercase text-bone">Owner login</h1>
        <p className="mt-2 text-sm text-zinc-400">Manage quote requests, gallery and branding.</p>
        <div className="mt-8 space-y-6">
          <input data-testid="admin-email-input" className={inputCls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="admin-password-input" className={inputCls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {err && <p data-testid="admin-login-error" className="mt-5 text-sm text-red-400">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-8 inline-flex w-full items-center justify-center gap-2 bg-brand py-4 font-display text-sm font-extrabold uppercase tracking-wider text-ink disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
